import React from 'react';
import { CheckIcon, ClockIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { pricingIncludes } from '../data/content';
import { useCountdown } from '../hooks/useCountdown';
export function Pricing() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section id="pricing" className="w-full bg-[#f7f7f8] px-5 py-16 sm:px-8" data-id="element-180" data-mp="2jkeb8sxxj0zu">
      <div className="mx-auto w-full max-w-xl" data-id="element-181" data-mp="1vutff9gog995">
        <div className="flex justify-center" data-id="element-182" data-mp="1rsgagn9r8fdf">
          <p className="rounded-full bg-[#ede9fe] px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wider text-[#6d28d9]" data-id="element-183" data-mp="1rthvnkkhii8v">
            Limited-time offer
          </p>
        </div>

        <h2 className="mt-5 text-center text-3xl font-extrabold leading-tight tracking-tight text-neutral-900 sm:text-4xl" data-id="element-184" data-mp="20s3d1ce7zr82">
          Everything included,{' '}
          <span className="text-[#6d28d9]" data-id="element-185" data-mp="3c8a6dt7uokui">one single price.</span>
        </h2>
        <p className="mt-4 text-center text-sm font-bold text-neutral-700" data-id="element-186" data-mp="3cae7y4ia17rm">
          Complete package. No upsells. No surprises.
        </p>

        <div className="relative mt-10 overflow-hidden rounded-3xl border border-neutral-200 bg-white shadow-sm" data-id="element-187" data-mp="4smd6n9zzxx7">
          <div className="h-1.5 w-full bg-[#6d28d9]" data-id="element-188" data-mp="9ta3t7ubecqw" />
          <div className="flex justify-center" data-id="element-189" data-mp="9qe35br319yr">
            <p className="rounded-b-xl bg-[#6d28d9] px-5 py-2 text-[11px] font-extrabold uppercase tracking-wider text-white" data-id="element-190" data-mp="eqa7xd7lt5fd">
              🏆 Complete offer
            </p>
          </div>

          <div className="px-6 py-8 sm:px-10" data-id="element-191" data-mp="3i93lhq0dtu9j">
            <h3 className="text-center text-xl font-extrabold uppercase leading-snug tracking-tight text-neutral-900 sm:text-2xl" data-id="element-192" data-mp="3i5xs3ykq0680">
              Netball Ready 360 + Tactical Playbook Pro
            </h3>
            <p className="mt-3 text-center text-sm font-semibold text-neutral-700" data-id="element-193" data-mp="3rzoij90eqqqc">
              6 Volumes + 5 Bonuses + Pro Tactical Kit
            </p>

            <p className="mt-7 text-center text-xs font-semibold text-neutral-500" data-id="element-194" data-mp="2zg9gnowh3ij1">
              Total value: <span className="line-through" data-id="element-195" data-mp="2rfjxninw4woq">$90</span>
            </p>

            <div className="mt-2 flex items-end justify-center gap-1" data-id="element-196" data-mp="2mibcrabcyejs">
              <span className="mb-3 text-2xl font-extrabold text-neutral-900" data-id="element-197" data-mp="2mfxih3oi56da">$</span>
              <span className="text-7xl font-extrabold leading-none tracking-tight text-neutral-900" data-id="element-198" data-mp="318qz4sfifsjj">
                27
              </span>
              <span className="mb-2 ml-1 text-sm font-semibold text-neutral-600" data-id="element-199" data-mp="28hh3kpghk9k2">
                one-time
              </span>
            </div>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-3" data-id="element-200" data-mp="23kqoa4ci9hzp">
              <span className="rounded-full bg-[#00c853] px-3.5 py-1.5 text-[11px] font-extrabold uppercase tracking-wider text-white" data-id="element-201" data-mp="2igy9n7zngpgk">
                Save $63
              </span>
              <span className="text-[11px] font-bold uppercase tracking-wider text-neutral-600" data-id="element-202" data-mp="3tuae9l38hc3s">
                Lifetime access
              </span>
            </div>

            <hr className="my-8 border-neutral-200" data-id="element-203" data-mp="anbqg8144pr" />

            <p className="text-center text-[11px] font-extrabold uppercase tracking-widest text-neutral-900" data-id="element-204" data-mp="8srl44l0gmq">
              What's included
            </p>
            <ul className="mx-auto mt-5 grid gap-3 sm:grid-cols-2" data-id="element-205" data-mp="3nflb8egzbofz">
              {pricingIncludes.map(item => <li key={item} className="flex items-center gap-2" data-id="element-206" data-mp="3rhq3p9voyf11">
                  <CheckIcon className="h-4 w-4 shrink-0 text-[#00c853]" aria-hidden="true" data-id="element-207" data-mp="j152if9awq8h" />
                  <span className="text-sm font-semibold text-neutral-900" data-id="element-208" data-mp="nzye22512760">{item}</span>
                </li>)}
            </ul>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-3 rounded-xl border border-neutral-200 bg-neutral-50 px-5 py-4" data-id="element-209" data-mp="a7i6co16lkyr">
              <span className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-neutral-700" data-id="element-210" data-mp="e7seo7cg4ngs">
                <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-211" data-mp="16q7k5n3xqj2z" />
                Ends in
              </span>
              <span className="text-center" data-id="element-212" data-mp="3f7sbbxmac7us">
                <span className="block text-sm font-extrabold tabular-nums text-[#6d28d9]" data-id="element-213" data-mp="3f8tl7yrkeoax">
                  {hours}:{minutes}:{seconds}
                </span>
                <span className="block text-[9px] font-bold uppercase tracking-widest text-neutral-500" data-id="element-214" data-mp="35adv9z49xl30">
                  HRS MIN SEC
                </span>
              </span>
            </div>

            <div className="mt-6" data-id="element-215" data-mp="1svrq3vjb08e">
              <CtaButton href="https://netball-ready-360.impultienda.ar/checkout" data-id="element-216" data-mp="1rublkznvnjt" />
            </div>

            <p className="mt-4 flex items-center justify-center gap-1.5 text-center text-xs font-semibold text-neutral-600" data-id="element-217" data-mp="3szoxll19vnj9">
              <ShieldCheckIcon className="h-3.5 w-3.5 text-[#00c853]" aria-hidden="true" data-id="element-218" data-mp="3k6lditw4gcfn" />
              Backed by our 7-day money-back guarantee
            </p>

            <hr className="my-7 border-neutral-200" data-id="element-219" data-mp="kkol3zeimngn" />

            <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-semibold text-neutral-700" data-id="element-220" data-mp="frvboy83qqy8">
              <li className="flex items-center gap-1.5" data-id="element-221" data-mp="1yggdn1uxn22s">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-222" data-mp="23dyd81n284y4" /> Secure Payment
              </li>
              <li className="flex items-center gap-1.5" data-id="element-223" data-mp="27g344sm4inh2">
                <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-224" data-mp="27eib57fgjclb" /> Instant Access
              </li>
              <li className="flex items-center gap-1.5" data-id="element-225" data-mp="2cctk7fxxhj2h">
                <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-226" data-mp="2heslmka3y5ws" /> 7-Day
                Guarantee
              </li>
            </ul>
            <p className="mt-3 flex items-center justify-center gap-1.5 text-xs font-semibold text-neutral-700" data-id="element-227" data-mp="2mazjdpscob3n">
              <CreditCardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-228" data-mp="2r66lit5z17qg" /> Card ·
              GooglePay · ApplePay
            </p>
          </div>
        </div>

        <p className="mt-6 text-center text-xs text-neutral-500" data-id="element-229" data-mp="3061zt6utpiup">
          💱 You'll be charged in your local currency
        </p>
      </div>
    </section>;
}